import { fromAPI, VisitMeasurementSummary } from "@cur8/rich-entity";
import { APITypesV1 } from "@cur8/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";
import { queryKey as visitMeasurementsKey } from "hooks/queries/useVisitMeasurementsQuery";

export function useStoreMeasurementMutation({
  patientId,
  visitId,
}: {
  patientId: string;
  visitId: string;
}) {
  const apiClient = useAPIClient();
  const queryClient = useQueryClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn(measurement: APITypesV1.CreateMeasurementRequest) {
      return apiClient.measurement.storeMeasurement({ patientId, measurement })
        .result;
    },
    onSuccess(dto) {
      const stored = fromAPI.toMeasurement(dto);
      const key = visitMeasurementsKey(patientId, visitId);
      queryClient.setQueryData(
        key,
        (old: VisitMeasurementSummary | undefined) => {
          const others = (old?.measurements ?? []).filter(
            (m) => m.metricName !== stored.metricName
          );
          return { measurements: [...others, stored] };
        }
      );
      queryClient.invalidateQueries({ queryKey: key, refetchType: "none" });
    },
    onError: (error) => logError(`Failed to store measurement: ${error}`),
  });
}
